import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  background-color: #ffffff;
  margin: 0 auto;

  .header {
    background-color: #ffffff;
  }

  border-radius: 0 0 1rem 1rem;

  .user {
    position: relative;

    &:hover {
      .user__options {
        display: flex;
      }
    }
  }

  .user__options {
    position: absolute;
    top: 100%;
    right: 0;

    z-index: 1;

    display: none;
    flex-direction: column;

    padding: 5px;

    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.23);

    span,
    a {
      color: #131e23 !important;
      font-size: 1rem;
      font-weight: bold;

      padding: 3px;

      cursor: pointer;
    }

    span:hover,
    a:hover {
      background-color: #dedede;
    }

    &::before {
      content: '';
      position: absolute;
      top: -10px;
      right: 5px;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #fff;
    }

    &:after {
      content: '';
      position: absolute;
      top: -20px;
      right: 0;
      left: 0;

      height: 30px;

      background-color: transparent;
    }
  }

  @media (max-width: 1024px) {
    width: auto;
    margin: 0px auto 0px 0px;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;

    > div {
      > div:nth-of-type(1) {
        margin-top: 10px;
      }
      > div:nth-of-type(3) {
        display: none;
      }
    }
  }
`;

export const Options = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Item = styled.div`
  cursor: pointer;
  transition: 0.5s all;
  margin-right: 40px;

  

  > a {
    font-family: 'Montserrat';
    font-weight: bold;
    font-size: 1rem;
    color: #00121c !important;
  }

  .active {
    color: #e84e22 !important;
  }

  &:hover {
    transform: scale(1.01);
  }
`;

export const MenuIcon = styled.div`
  display: none;

  margin-top: 10px;
  margin-left: 20px;
  cursor: pointer;

  div {
    width: 40px;
    height: 6px;
    margin-bottom: 4px;
    background-color: var(--green00);
  }

  @media (max-width: 1024px) {
    display: block;
    div {
      width: 32px;
      height: 4px;
      margin-bottom: 3px;
    }
  }
`;

export const Logo = styled.img`
  cursor: pointer;
  width: 10rem;
  height: auto;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Button = styled.button`
  font-family: 'Montserrat';
  font-size: 1rem;
  font-weight: 700;

  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 2rem;
  width: 5rem;

  background-color: #e84e22;

  border: 0;
  border-radius: 2rem;
  outline: 0;

  @media (max-width: 1024px) {
    display: none;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const UserPhoto = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-left: 40px;
  object-fit: cover;

  @media (max-width: 1024px) {
    margin-left: 0px;
    display: none;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const ContainerOnlyAppearsVersionMobile = styled.div`
  display: none;
  > img {
    height: 30px;
  }

  span {
    font-family: 'Montserrat';
    color: var(--green00);
    margin-left: 10px;
    font-size: 2.2rem;
  }

  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
`;
